import React, {PureComponent} from 'react';
import {Swiper, SwiperSlide} from 'swiper/swiper-react';
import ChatSmileItem from 'app/components/chat/chat_smile_item';
import {isDesktop} from 'app/utils/windowFunctions';

const SWIPER_ITEMS_COUNT = 6;

const swiperParams = {
    allowTouchMove: true
};

export default class ChatSmileItemsSlider extends PureComponent {
    render() {
        const {smiles, insertSmile} = this.props;
        const hasSmiles = smiles.length > 0;
        const isDesktopWithSlider = isDesktop() && smiles.length > SWIPER_ITEMS_COUNT;

        return hasSmiles && (
            isDesktopWithSlider
                ? <div className="chat__smile-item-list slider-recent-smileys">
                    <Swiper className="slider-smileys" {...swiperParams} slidesPerView="auto">
                        {smiles.map(smile => <SwiperSlide key={smile}>
                            <ChatSmileItem
                                key={smile}
                                smile={smile}
                                insertSmile={insertSmile}
                            />
                        </SwiperSlide>)}
                    </Swiper>
                </div>
                : <div className="chat__smile-item-list slider-recent-smileys-mobile">
                    {smiles.map(smile => <ChatSmileItem
                        key={smile}
                        smile={smile}
                        insertSmile={insertSmile}
                    />)}
                </div>
        );
    }
}
